import { toCamelCase } from './strings'
import { DASHBOARD_ROUTES } from '../app/routing/routesLinks'
import {
  faGear as gearRegular,
  faSquarePollVertical as pollRegular,
  faMagnifyingGlassChart as magnifyingRegular,
  faChartLineUp as lineChartRegular,
  faChartPieSimple as pieRegular,
  faChartPie as pieRegular2,
  faCircleXmark as crossRegular,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faGear as gearSolid,
  faSquarePollVertical as pollSolid,
  faMagnifyingGlassChart as magnifyingSolid,
  faChartLineUp as lineChartSolid,
  faChartPieSimple as pieSolid,
  faChartPie as pieSolid2,
  faCircleXmark as crossSolid,
} from '@fortawesome/pro-solid-svg-icons'

export const TILES_TYPE = {
  physician: 'phy',
  app: 'app',
  other: 'other',
}

export const TILES_ICONS = {
  phymanagedata: {
    default: gearRegular,
    hover: gearSolid,
  },
  phyaag: {
    default: magnifyingRegular,
    hover: magnifyingSolid,
  },
  physurveyreport: {
    default: pollRegular,
    hover: pollSolid,
  },
  phymarketpositioning: {
    default: lineChartRegular,
    hover: lineChartSolid,
  },
  phymarketmodeling: {
    default: pieRegular,
    hover: pieSolid,
  },
  phymarkettrends: {
    default: pieRegular2,
    hover: pieSolid2,
  },
  phyoppassessmt: {
    default: lineChartRegular,
    hover: lineChartSolid,
  },
  appmanagedata: {
    default: gearRegular,
    hover: gearSolid,
  },
  appaag: {
    default: magnifyingRegular,
    hover: magnifyingSolid,
  },
  appsurveyreport: {
    default: pollRegular,
    hover: pollSolid,
  },
  appmarketpositioning: {
    default: lineChartRegular,
    hover: lineChartSolid,
  },
  appmarketmodeling: {
    default: pieRegular,
    hover: pieSolid,
  },
  appmarkettrends: {
    default: pieRegular2,
    hover: pieSolid2,
  },
  otheroncall: {
    default: crossRegular,
    hover: crossSolid,
  },
  default: {
    default: pollRegular,
    hover: pollSolid,
  },
}

export function getTileIconFromCode(code) {
  return TILES_ICONS[code] || TILES_ICONS.default
}

export function setDataCy(element, params) {
  const urlReplaced = params?.url?.replace(/\//g, '-')
  switch (element) {
    case 'container':
      if (params?.type === 'Other') return `tile-other-on-call`
      return `tile-${params?.type}-${params?.title.toLowerCase().replaceAll(' ', '-')}`
    case 'icon':
      return `icon-${params?.tileIcon}-cy`
    case 'title':
      return `${toCamelCase(params?.title) || 'title'}-text-cy`
  }
}

function orderTiles(arr) {
  return arr.sort((a, b) => a.order - b.order)
}

export function handleTiles(tiles) {
  const onCallClientUrl = import.meta.env.VITE_PAY_PRACTICE_URL || '/'
  let tilesUpdated = tiles.map(tile => {
    tile.type = tile.type?.toLowerCase()

    let isPhysician = tile.type === 'phy'
    let isOther = tile.type === 'other'

    const dashboardType = isPhysician ? 'physicianDashboards' : 'appDashboards'
    tile.url = isOther ? onCallClientUrl : DASHBOARD_ROUTES[dashboardType][tile.code]?.url || '/'
    tile.fullType = DASHBOARD_ROUTES[dashboardType][tile.code]?.fullType || 'Other'
    tile.order = DASHBOARD_ROUTES[dashboardType][tile.code]?.order || 9
    return tile
  })

  return orderTiles(tilesUpdated)
}

export function filterTiles(tiles, type) {
  return tiles.filter(tile => tile.type?.toLowerCase() === type?.toLowerCase())
}

export const ToolTipDescription = {
  managedata: {
    description: `Compile, blend, upload, and compare market data. Access SullivanCotter surveys and create custom 
modules for tailored insights. View your organization’s survey submissions or upload incumbent data.`
  },
  aag: {
    description: `Quickly gain visual insights into a single provider’s compensation and productivity. Input provider details, 
select market data sources, and generate PDF reports that plot percentiles for easy comparison and 
strategic planning.`,
  },
  surveyreport: {
    description: `Access and filter market data effortlessly. Choose between a comprehensive specialty-focused view or a 
detailed view, and filter by specific data variables.`,
  },
  marketpositioning: {
    description: `Compare organization data to market benchmarks. Calculate TCC (Total Cash Compensation), wRVU 
percentiles, and identify alignment. View detailed results at incumbent, specialty, and group levels with 
tables and graphs. Includes an opportunity assessment to pinpoint areas of success and opportunities for
improvement.`,
    url: 'BM360support@sullivancotter.com'
  },
  marketmodeling: '',
  markettrends: '',
  oppassessmt: '',
}
